const bikeNumToEnumStatuses = {
  0: "HIDDEN",
  1: "FREE",
  2: "BOOKED",
  3: "RIDING",
  4: "TRANSFER",
  5: "GARAGE",
  6: "BROKEN",
  7: "POLICE",
  8: "LOST",
};
const bikeEnumToNumStatuses = {
  HIDDEN: 0,
  FREE: 1,
  BOOKED: 2,
  RIDING: 3,
  TRANSFER: 4,
  GARAGE: 5,
  BROKEN: 6,
  POLICE: 7,
  LOST: 8,
};

export {
  bikeNumToEnumStatuses,
  bikeEnumToNumStatuses
};

export const SCOOTER_STATUSES = [
  "HIDDEN", "FREE", "BOOKED", "RIDING", "TRANSFER", "GARAGE", "BROKEN", "POLICE", "LOST"
];



// WEBPACK FOOTER //
// ./src/data/bike-numeric-statuses.js